import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";

import './LoginFailedPopUp.style.scss';
import {FormattedMessage} from "react-intl";
const LoginFailedPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options}) => {


    return (
        <Dialog open={open} onClose={onClose} className="LoginFailedPopUp">
            <DialogContent className="LoginFailedContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    <FormattedMessage id={'popUp.loginFailed.title'}/>
                </Typography>
                <Typography className="subTitle">
                    <FormattedMessage id={'popUp.loginFailed.subTitle'}/>
                </Typography>

                <div className={'actionButton'}>
                    <Button className="login" onClick={() => {
                        onOk()
                    }}>
                        <FormattedMessage id={'popUp.loginFailed.tryAgain'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default LoginFailedPopUp;
